/*
 * AvailabilityCell.jsx
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../icons/Icons';

const propTypes = {
    count: PropTypes.number,
    isSelected: PropTypes.bool,
    onSelectToggle: PropTypes.func
};

export default class AvailabilityCell extends React.Component {
    render() {
        if (this.props.isSelected) {
            return (
                <td className="selected">
                    <div className="rec-full-button-wrap">
                        <button
                            className="rec-availability-date selected"
                            onClick={this.props.onSelectToggle}>
                            <Icons.IconCheck />
                        </button>
                    </div>
                </td>
            );
        }

        if (this.props.count && this.props.count > 0) {
            return (
                <td className="available">
                    <div className="rec-full-button-wrap">
                        <button
                            className="rec-availability-date"
                            onClick={this.props.onSelectToggle}>
                            {this.props.count}
                        </button>
                    </div>
                </td>
            );
        }

        return (
            <td className="unavailable">
                0
            </td>
        );
    }
}

AvailabilityCell.propTypes = propTypes;
